<template>
  <div class="bigdata-contains">
    <MyHeader />

    <div class="main-w">
      <!-- 交易排名 -->
      <Ranking />

      <!-- 中心块 -->
      <div class="center-w">
        <div class="top">
          <TotalData :data="statisData.listingArea" title="总挂牌面积" :unit="(statisData.listingUnit || '') +'亩'" />
          <TotalData :data="statisData.varea" title="总成交面积" :unit="(statisData.vareaUnit || '')+'亩'" />
          <TotalData :data="statisData.gmv" title="总成交金额" :unit="(statisData.gmvUnit || '')+'元'" />
          <TotalData :data="statisData.vol" title="总成交数量" :unit="(statisData.volUnit || '')+'宗'" />
        </div>
        <!-- 实时竞拍动态 -->
        <AuctionDynamic />
      </div>

      <!-- 成交公示 -->
      <Announcement />
    </div>
  </div>
</template>

<script>
import Announcement from './components/Announcement.vue'
import AuctionDynamic from './components/AuctionDynamic.vue'
import MyHeader from './components/MyHeader.vue'
import Ranking from './components/Ranking.vue'
import TotalData from './components/TotalData.vue'

import { data_statis } from '@/api/portal'
import { mapGetters } from 'vuex'

export default {
  components: {
    Announcement,
    AuctionDynamic,
    MyHeader,
    Ranking,
    TotalData
  },

  data() {
    return {
      rankingScrollTop: 0,
      statisData: {} // 汇总统计数据
    }
  },
  computed: {
    ...mapGetters(['siteInfo'])
  },
  watch:{
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.initBigData()
        }
      },
      immediate:true,
      deep:true
    }
  },
  created() {

  },
  methods: {

    // 初始大屏数据
    async initBigData() {
      const { data: statisData } = await data_statis() // 获取汇总统计数据 api
      this.statisData = statisData
    }

  }
}
</script>

<style lang="scss" scoped>
.bigdata-contains {
  width: 1920px;
  height: 1080px;
  margin: 0 auto;
  background: #011029 url('./assets/images/bigdata_3.png') 65% 33% no-repeat;

  .main-w {
    display: flex;
    justify-content: space-between;
    height: 936px;
    margin: 16px 0;
    padding: 0 50px;
    .center-w {
      width: 1042px;
      .top {
        display: flex;
        justify-content: space-between;
      }
    }
  }

}
</style>
